// extracted by mini-css-extract-plugin
export var alertIcon = "_mm-0";